import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { kontakteApi } from '../api';

export default function KontaktePage() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ nachname: '', vorname: '', email: '', telefon: '', rolle: 'Ansprechpartner' });
  const [saving, setSaving] = useState(false);
  const pageSize = 25;

  const load = useCallback(async () => {
    setLoading(true); setErr(null);
    try {
      const r = await kontakteApi.list({ search: search || undefined, page, pageSize });
      setRows(r.rows || []); setTotal(r.total || 0);
    } catch (e) { setErr(e.response?.data?.error || e.message); }
    finally { setLoading(false); }
  }, [search, page]);

  useEffect(() => { load(); }, [load]);

  const handleCreate = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await kontakteApi.create(form);
      setShowForm(false); setForm({ nachname: '', vorname: '', email: '', telefon: '', rolle: 'Ansprechpartner' });
      load();
    } catch (e) { alert(e.response?.data?.error || e.message); }
    finally { setSaving(false); }
  };

  return (
    <div style={{ padding: 20, color: '#f1f5f9', maxWidth: 1000 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, margin: 0 }}>👤 Kontakte</h1>
        <button onClick={() => setShowForm(!showForm)} style={btn('#6366f1')}>+ Neuer Kontakt</button>
      </div>

      {showForm && (
        <form onSubmit={handleCreate} style={{ background: '#1e293b', border: '1px solid #334155', borderRadius: 10, padding: 16, marginBottom: 16 }}>
          <h3 style={{ margin: '0 0 12px', fontSize: 15 }}>Neuer Kontakt</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
            <input required placeholder="Nachname *" value={form.nachname} onChange={e => setForm(p => ({...p, nachname: e.target.value}))} style={inputStyle} />
            <input placeholder="Vorname" value={form.vorname} onChange={e => setForm(p => ({...p, vorname: e.target.value}))} style={inputStyle} />
            <input type="email" placeholder="E-Mail" value={form.email} onChange={e => setForm(p => ({...p, email: e.target.value}))} style={inputStyle} />
            <input placeholder="Telefon" value={form.telefon} onChange={e => setForm(p => ({...p, telefon: e.target.value}))} style={inputStyle} />
            <select value={form.rolle} onChange={e => setForm(p => ({...p, rolle: e.target.value}))} style={inputStyle}>
              {['Kundenservice','Vertragsservice','Kündigungsstelle','Ansprechpartner','Makler','Vertreter','Buchhaltung','Datenschutz','technischer Support','Vertrieb','sonstiges'].map(r => <option key={r}>{r}</option>)}
            </select>
            <input placeholder="Abteilung" value={form.abteilung || ''} onChange={e => setForm(p => ({...p, abteilung: e.target.value}))} style={inputStyle} />
          </div>
          <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
            <button type="submit" disabled={saving} style={btn('#6366f1')}>{saving ? '…' : 'Speichern'}</button>
            <button type="button" onClick={() => setShowForm(false)} style={btn('#334155')}>Abbrechen</button>
          </div>
        </form>
      )}

      <input value={search} onChange={e => { setSearch(e.target.value); setPage(1); }}
        placeholder="Name, E-Mail, Abteilung…" style={{ ...inputStyle, width: '100%', marginBottom: 14, maxWidth: 360 }} />

      {err && <div style={{ background: '#7f1d1d', padding: 12, borderRadius: 8, marginBottom: 12 }}>{err}</div>}

      {loading ? (
        <div style={{ textAlign: 'center', color: '#6366f1', padding: 40 }}>⏳ Lade…</div>
      ) : rows.length === 0 ? (
        <div style={{ textAlign: 'center', color: '#64748b', padding: 40 }}>
          <div style={{ fontSize: 36 }}>👤</div>
          <div style={{ marginTop: 10 }}>Noch keine Kontakte vorhanden.</div>
        </div>
      ) : (
        <>
          <div style={{ color: '#94a3b8', fontSize: 13, marginBottom: 8 }}>{total} Kontakte gesamt</div>
          <div style={{ display: 'grid', gap: 8 }}>
            {rows.map(k => (
              <div key={k.id} onClick={() => navigate(`/kontakte/${k.id}`)}
                style={{ background: '#1e293b', border: '1px solid #334155', borderRadius: 8, padding: '12px 14px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 12 }}>
                <div style={{ width: 38, height: 38, background: '#334155', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 15, color: '#818cf8', flexShrink: 0 }}>
                  {(k.vorname || k.nachname || '?')[0].toUpperCase()}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontWeight: 500 }}>{[k.vorname, k.nachname].filter(Boolean).join(' ')}</div>
                  <div style={{ color: '#64748b', fontSize: 12 }}>{k.rolle}{k.abteilung ? ` · ${k.abteilung}` : ''}{k.anbieter_name ? ` · ${k.anbieter_name}` : ''}</div>
                  {k.email && <div style={{ color: '#94a3b8', fontSize: 12 }}>{k.email}</div>}
                </div>
                {k.ist_primaer ? <span style={{ color: '#6366f1', fontSize: 12 }}>★ Primär</span> : null}
              </div>
            ))}
          </div>
          {total > pageSize && (
            <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginTop: 16 }}>
              <button onClick={() => setPage(p => Math.max(1,p-1))} disabled={page === 1} style={btn('#334155')}>‹ Zurück</button>
              <span style={{ padding: '6px 12px', color: '#94a3b8', fontSize: 13 }}>{page} / {Math.ceil(total/pageSize)}</span>
              <button onClick={() => setPage(p => p+1)} disabled={page >= Math.ceil(total/pageSize)} style={btn('#334155')}>Weiter ›</button>
            </div>
          )}
        </>
      )}
    </div>
  );
}

const btn = (bg) => ({ background: bg, color: '#f1f5f9', border: 'none', padding: '8px 14px', borderRadius: 6, cursor: 'pointer', fontSize: 13 });
const inputStyle = { background: '#1e293b', border: '1px solid #334155', color: '#f1f5f9', padding: '8px 10px', borderRadius: 6, fontSize: 13, boxSizing: 'border-box' };
